import { ApiState, GlobalAction } from '.';

const START = '_START';
const SUCCESS = '_SUCCESS';
const ERROR = '_ERROR';
const LIBRARY = 'INIT_LIBRARY';
const LIBRARY_REFRESH = 'LIBRARY_REFRESH';

export const apiReducer = (state: ApiState, action: GlobalAction): any => {
  const { payload, type, pathname } = action;
  if (type.includes(LIBRARY + START)) {
    return { ...state, firstAppLoad: 1, loading: true };
  }
  if (type.includes(LIBRARY + SUCCESS)) {
    return { ...state, firstAppLoad: 2 };
  }
  if (type.includes(LIBRARY + ERROR)) {
    return { ...state, firstAppLoad: 2 };
  }
  if (type.includes(LIBRARY_REFRESH)) {
    return { ...state, firstAppLoad: 0 };
  }
  if (type.includes(START)) {
    let newState: any = { ...state, loading: true };
    if (pathname) {
      newState = { ...state, [pathname]: { loading: true } };
    }
    return newState;
  }
  if (type.includes(ERROR)) {
    let newState: any = { ...state, loading: false, error: payload };
    if (pathname) {
      newState = { ...state, [pathname]: { loading: false }, error: payload };
    }
    return newState;
  }
  if (type.includes(SUCCESS)) {
    let newState: any = { ...state, loading: false };
    if (pathname) {
      newState = { ...state, [pathname]: { loading: false } };
    }
    return newState;
  }

  return state;
};
